import { Modal } from 'react-bootstrap';
import { useState, type VoidFunctionComponent } from 'react';
import * as _ from 'lodash';
import Button, { BUTTON_SIZE, BUTTON_TYPE, LoaderButton } from '../../../generic/Button';
import { Icon, icons, LabeledTextInput } from '../../../generic';
import useCreateGitHubAppInstallation from './useCreateGitHubAppInstallation';

const AddGitHubAppButton: VoidFunctionComponent = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [gitHubInstallationId, setGitHubInstallationId] = useState<string>('');
  const [ownerName, setOwnerName] = useState<string>('');
  const { error, isLoading, mutate: createGitHubApp, reset } = useCreateGitHubAppInstallation();

  const onOpen = () => setIsOpen(true);
  const onClose = () => {
    setGitHubInstallationId('');
    setOwnerName('');
    reset();
    setIsOpen(false);
  };

  const onSubmit = () => {
    createGitHubApp({ gitHubInstallationId, name: ownerName }, { onSuccess: onClose });
  };

  const isNotValid = _.isEmpty(gitHubInstallationId) || gitHubInstallationId.length < 2
    || _.isEmpty(ownerName) || ownerName.length < 2;

  return (
    <>
      <Button type={BUTTON_TYPE.SECONDARY} size={BUTTON_SIZE.MEDIUM} onClick={onOpen}>
        <Icon icon={icons.add} />
        Add GitHub App
      </Button>
      <Modal onHide={onClose} backdrop show={isOpen}>
        <Modal.Header closeButton>
          <Modal.Title>
            Add GitHub App Installation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            error &&
            <p className="alert alert-error">Error while creating installation: { error.message }</p>
          }
          <LabeledTextInput
            label="Installation ID"
            placeholder="GitHub Installation ID"
            onChange={(v) => setGitHubInstallationId(v)}
            value={gitHubInstallationId}
            testId="gitHubInstallationId"
          />
          <LabeledTextInput
            label="Owner Name"
            placeholder="GitHub Org or User name"
            onChange={(v) => setOwnerName(v)}
            value={ownerName}
            testId="ownerName"
          />
        </Modal.Body>
        <Modal.Footer>
          <LoaderButton
            isDisabled={isNotValid || isLoading}
            isLoading={isLoading}
            size={BUTTON_SIZE.MEDIUM}
            onClick={onSubmit}
            testId="submitAddInstallation"
          >
            Add Installation
          </LoaderButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddGitHubAppButton;
